import { render, staticRenderFns } from "./GameError.vue?vue&type=template&id=2249d2c3&scoped=true"
import script from "./GameError.vue?vue&type=script&lang=js"
export * from "./GameError.vue?vue&type=script&lang=js"
import style0 from "./GameError.vue?vue&type=style&index=0&id=2249d2c3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2249d2c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2249d2c3')) {
      api.createRecord('2249d2c3', component.options)
    } else {
      api.reload('2249d2c3', component.options)
    }
    module.hot.accept("./GameError.vue?vue&type=template&id=2249d2c3&scoped=true", function () {
      api.rerender('2249d2c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/GameError.vue"
export default component.exports